import { render, staticRenderFns } from "./filterBlock.vue?vue&type=template&id=16b18912&scoped=true"
import script from "./filterBlock.vue?vue&type=script&lang=js"
export * from "./filterBlock.vue?vue&type=script&lang=js"
import style0 from "./filterBlock.vue?vue&type=style&index=0&id=16b18912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b18912",
  null
  
)

export default component.exports